import React from 'react';
import { Platform, ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, DisplayText } from '@garnish/core';

export const MobileHeader = ({
  testID: baseTestID,
  titleTestID,
  subtitleTestID,
  title,
  subtitle,
  style,
}: MobileHeaderProps) => {
  return (
    <View testID={baseTestID ?? 'sg-mobile-header'} style={[styles.container, style]}>
      {title ? (
        <DisplayText
          testID={titleTestID ?? baseTestID?.concat('.title')}
          sizeMatch={['24', '32']}
          style={[styles.title, !subtitle && styles.margin]}
        >
          {title}
        </DisplayText>
      ) : null}
      {subtitle ? (
        <BodyText
          testID={subtitleTestID ?? baseTestID?.concat('.subtitle')}
          sizeMatch={['14']}
          style={[styles.subtitle, Boolean(subtitle) && styles.margin]}
        >
          {subtitle}
        </BodyText>
      ) : null}
    </View>
  );
};

type MobileHeaderProps = Readonly<{
  title?: string;
  subtitle?: string;
  testID?: string;
  titleTestID?: string;
  subtitleTestID?: string;
  style?: ViewProps['style'];
}>;

const styles = StyleSheet.create({
  container: {
    paddingTop: Platform.select({
      ios: theme.spacing['2'],
      default: theme.spacing['1'],
    }),
  },
  title: {
    fontSize: 32,
    paddingVertical: theme.spacing['2'],
  },
  subtitle: {
    paddingVertical: theme.spacing['2'],
  },
  margin: {
    marginBottom: theme.spacing['6'],
  },
});
